import { DashboardViewFragment } from 'generated/graphql';

export function getDashboardListItemFromDashboardView(
  dashboard: DashboardViewFragment,
) {
  return {
    __typename: 'DashboardListItem' as const,
    id: dashboard.id,
    title: dashboard.title,
    description: dashboard.description || '',
    viewToken: dashboard.viewToken,
    editToken: dashboard.editToken || '',
    scope: dashboard.scope,
    createdBy: dashboard.createdBy,
    recency: Math.floor(Date.now() / 1000), // Unix timestamp in seconds
    analysisIDs: dashboard.widgets?.map((w) => w.id) || [],
    shortMetadata: dashboard.shortMetadata,
    createdAt: dashboard.createdAt,
    tenantID: dashboard.tenantID,
    useCase: dashboard.useCase,
    version: dashboard.version,
    metadataV2: dashboard.metadataV2,
  };
}
